'use strict';

const directions = /** @type {const} */ ({
  ascending: 'ascending',
  descending: 'descending',
});

module.exports = directions;
